export type PermissionActions = (typeof permissionActions)[keyof typeof permissionActions]

export const permissionActions = {
  manage: 'manage',
  create: 'create',
  read: 'read',
  update: 'update',
  delete: 'delete'
} as const
